import React from 'react';
import Image from "./labo.png"; // Image supplémentaire
import "./Materiel.css"
const Materiel = () => {
  return (



 <>


<div className='labo' style={{textAlign:"center"}}>
<span className="okkkkk">CENTRE DE CALCUL HAUTE PERFORMANCE ET DATA-CENTER </span>
 <span className="okkkkkk"> HAUTE PERFORMANCE </span>
 <span className="okkkkk"> ET DATA-CENTER </span>


</div>
       <div className='resp' style={styles.container}>

    
<div  style={styles.left}>
  <p style={styles.description}>
    Notre Centre de Calcul Haute Performance et Data-Center, équipés de
    supercalculateurs et de serveurs à haute capacité, permettent de traiter
    des volumes massifs de données rapidement. Le Centre de Calcul dispose de
    processeurs multicœurs et de GPU dédiés, optimisés pour les simulations
    complexes et l'analyse de grandes bases de données, offrant une puissance
    exceptionnelle aux chercheurs et étudiants. Le Data-Center propose des
    systèmes de stockage avancés avec des configurations RAID et des mesures de
    sécurité rigoureuses, garantissant la protection des données et une
    disponibilité continue. Intégrées dans un réseau sécurisé et à haute
    disponibilité, ces infrastructures soutiennent l'excellence scientifique.
  </p>
</div>
<div style={styles.right}>
  <img src={Image} alt="Centre de Calcul" style={styles.image} />
</div>
</div>

 </>


  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    marginTop: '30px',
    textAlign:"center"
  },
  left: {
    flex: 1,
    paddingRight: '30px',
  },
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '15px',
  },
  description: {
    fontSize: '16px',
    lineHeight: '1.6',
    color: '#555',
    maxWidth: '500px',
  },
  right: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '100%',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
};

export default Materiel;
